document.addEventListener("DOMContentLoaded", function () {
  const routineSections = document.querySelectorAll(".routine-pdp");

  routineSections.forEach((section) => {
    const previewWrappers = section.querySelectorAll('[data-autoplay-preview="true"]');
    const standardWrappers = section.querySelectorAll(
      ".routine-media-wrapper:not([data-autoplay-preview])"
    );
    const allFullVideos = [];

    function loadVideoSources(video) {
      const sources = video.querySelectorAll("source[data-src]");
      if (sources.length === 0) return;
      sources.forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute("data-src");
      });
      video.load();
    }

    function pauseAllFullVideosExcept(current) {
      allFullVideos.forEach((entry) => {
        if (entry.video !== current && !entry.video.paused) {
          entry.video.pause();
        }
      });
    }

    /* ── Preview-enabled wrappers (preview clip + full video) ── */
    previewWrappers.forEach((wrapper) => {
      const previewVideo = wrapper.querySelector(".routine-preview-video");
      const fullVideo = wrapper.querySelector(".routine-full-video");
      if (!previewVideo || !fullVideo) return;

      let previewSourcesLoaded = false;
      let fullSourcesLoaded = false;

      allFullVideos.push({ video: fullVideo, wrapper: wrapper });

      function startFullPlayback() {
        pauseAllFullVideosExcept(fullVideo);
        previewVideo.pause();
        wrapper.classList.add("is-playing");

        if (!fullSourcesLoaded) {
          loadVideoSources(fullVideo);
          fullSourcesLoaded = true;
        }
        fullVideo.currentTime = 0;
        fullVideo.play().catch(() => {});
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!previewSourcesLoaded) {
                loadVideoSources(previewVideo);
                previewSourcesLoaded = true;
              }
              if (!wrapper.classList.contains("is-playing")) {
                previewVideo.muted = true;
                previewVideo.currentTime = 0;
                previewVideo.play().catch(() => {});
              }
            } else {
              previewVideo.pause();
              fullVideo.pause();
            }
          });
        },
        { root: null, rootMargin: "0px", threshold: 0.25 }
      );
      observer.observe(wrapper);

      fullVideo.addEventListener("play", function () {
        pauseAllFullVideosExcept(fullVideo);
      });

      wrapper.addEventListener("click", function (e) {
        if (e.target.closest("a")) return;
        if (wrapper.classList.contains("is-playing")) return;
        startFullPlayback();
      });

      fullVideo.addEventListener("ended", function () {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch(() => {});
        } else if (document.webkitFullscreenElement) {
          document.webkitExitFullscreen();
        } else if (fullVideo.webkitDisplayingFullscreen) {
          fullVideo.webkitExitFullscreen();
        }
        wrapper.classList.remove("is-playing");
        fullVideo.currentTime = 0;
        previewVideo.play().catch(() => {});
      });
    });

    /* ── Standard (non-preview) videos ── */
    standardWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector(".routine-main-video");
      if (!video) return;

      let sourcesLoaded = false;
      allFullVideos.push({ video: video, wrapper: null });

      video.addEventListener("play", () => {
        pauseAllFullVideosExcept(video);
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!sourcesLoaded) {
                loadVideoSources(video);
                sourcesLoaded = true;
              }
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { root: null, rootMargin: "0px", threshold: 0.25 }
      );
      observer.observe(wrapper);
    });
  });
});
